/**
 * Resolves the display label for a curated card CTA button.
 * Returns undefined to let ButtonEl fall back to link.name.
 * isMember: true = logged in, false = not logged in, null = unknown (treated as not logged in)
 */
export const resolveCTALabel = (cardItem, ctaLinkItem, isMember) => {
  if (cardItem?.metaBadgeData?.isLocked && !isMember) {
    return cardItem?.ctaTitleWhenSignedOut || undefined
  }
  return cardItem?.ctaTitleWhenSignedIn || undefined
}
